import { Icon } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"
import { MRT_Row } from "material-react-table"
import { OrganisationDto } from "@custom-types/organisation"
import { ContractDto } from "@custom-types/contract"
import { DivisionDto } from "@custom-types/division"

export const getMaterialTableColumns = () => [
  {
    accessorKey: "name",
    header: "Name",
    size: 100,
  },
  {
    accessorKey: "email_domains",
    header: "Email Domains",
  },
  {
    accessorKey: "total_contracts",
    header: "Number of Contracts",
    size: 50,
    muiTableBodyCellProps: {
      align: "right",
    },
  },
  {
    accessorKey: "total_users",
    header: "Number of Users",
    size: 50,
    muiTableBodyCellProps: {
      align: "right",
    },
  },
  {
    accessorKey: "active",
    header: "Active",
    Cell: ({ row }: { row: MRT_Row<OrganisationDto> }) => (
      <Icon fontSize="small">{row.original.active ? <CheckIcon /> : <CloseIcon />}</Icon>
    ),
    size: 25,
    muiTableBodyCellProps: {
      align: "center",
    },
  },
]

export const isDivisionUsed = (divisionKey: string, contracts: ContractDto[]) => {
  return contracts.some(({ division_key }) => division_key === divisionKey)
}

export const getDivisionsToDelete = (
  existingDivisions: DivisionDto[],
  updatedDivisions: DivisionDto[],
) => {
  const updatedDivisionsIds = updatedDivisions.map((division) => division.key)

  return existingDivisions.filter(({ key }) => !updatedDivisionsIds.includes(key))
}
